import React, { Fragment } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const UpdateServiceCell = ({ location }) => {
  if (location.subscriptions
      && location.subscriptions.length
  ) {
    const currentItems = []
    const futureItems = []
    location.subscriptions.forEach((subscription) => {
      if (subscription.items && subscription.items.length) {
        const startDate = dayjs(subscription.startDate).utc()
        const today = dayjs().utc()
        const endDate = subscription.endDate ? dayjs(subscription.endDate).utc() : null

        if (!(endDate && endDate.isBefore(today, 'date'))) {
          subscription.items.forEach((item) => {
            if (!startDate.isAfter(today, 'date')) {
              currentItems.push(item)
            } else {
              futureItems.push({
                ...item,
                name: `${item.name} (${dayjs(startDate).utc().format('MM/DD/YYYY')})`
              })
            }
          })
        }
      }
    })

    const combinedItems = [
      ...combineItems(currentItems),
      ...combineItems(futureItems)
    ]

    return (
      <Fragment>
        <ul style={{ marginTop: '0px', marginLeft: '-28px' }}>
          {combinedItems.map((item) => {
            return (
              <li key={item.name}>
                {generateItemString(item)}
              </li>
            )
          })}
        </ul>
      </Fragment>
    )
  }

  return null
}

const combineItems = (itemArray) => {
  const combinedItems = []
  itemArray.forEach((item) => {
    const obj = combinedItems.find((o) => o.sku === item.sku)
    if (obj) {
      obj.quantity += item.quantity
    } else if (item.quantity > 0) {
      combinedItems.push(item)
    }
  })

  return combinedItems
}

const generateItemString = (item) => {
  const itemName = item.startDate ? `${item.name} (${dayjs(item.startDate).format('MM/DD/YYYY')})` : item.name

  return `${itemName} - ${item.quantity} ${item.quantity === 1 ? 'service' : 'services'}`
}

export default UpdateServiceCell
